export function faqAnchor(question: string) {
  return (
    'faq-' +
    question
      .toLowerCase()
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 72)
  )
}
